// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.services .custom-container .content-section {
  padding: 5rem 0rem;
  min-height: 55vh;
  background: #E0E7FF;
}
.services .custom-container .content-section .page-title {
  font-size: 2.2rem;
  text-align: center;
  color: #08245A;
}
.services .custom-container .content-section .page-title::after {
  content: "";
  display: block;
  height: 8px;
  width: 60px;
  background: #08245A;
  margin: 0.7rem auto 0;
  border-radius: 20px;
}
.services .custom-container .content-section .content-body {
  margin: 3rem auto 0;
  max-width: 1280px;
}
.services .custom-container .content-section .content-body .custom-service-card {
  background: #fff;
  height: 300px;
  padding: 1rem;
  border-radius: 12px;
  margin-bottom: 2.5rem;
  cursor: pointer;
  transition: 0.5s;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.services .custom-container .content-section .content-body .custom-service-card .custom-service-card-header {
  background: rgba(53, 78, 128, 0.9);
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  clip-path: polygon(0 0, 100% 0, 100% 80%, 0% 100%);
}
.services .custom-container .content-section .content-body .custom-service-card .custom-service-card-header img {
  width: 85px;
  height: 100px;
  object-fit: contain;
}
.services .custom-container .content-section .content-body .custom-service-card .custom-service-card-body {
  height: calc(300px - 1rem - 200px);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.services .custom-container .content-section .content-body .custom-service-card .custom-service-card-body .service-name {
  font-weight: 500;
  font-size: 1.1rem;
  color: #08245A;
  font-family: "Roboto", "SolaimanLipi", sans-serif;
}
.services .custom-container .content-section .content-body .custom-service-card:hover {
  transform: translateY(-10px);
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/pages/services/style.scss","webpack://./src/assets/css/common/_variables.scss"],"names":[],"mappings":"AAII;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AAHN;AAKM;EACE,iBCGK;EDFL,kBAAA;EACA,cAAA;AAHR;AAKQ;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;AAHV;AAOM;EACE,mBAAA;EACA,iBAAA;AALR;AAOQ;EACE,gBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;AALV;AAOU;EACE,kCAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kDAAA;AALZ;AAOY;EACE,WAAA;EACA,aAAA;EACA,mBAAA;AALd;AAUU;EACE,kCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AARZ;AAUY;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iDAAA;AARd;AAYU;EACE,4BAAA;EACA,2FAAA;AAVZ","sourcesContent":["@import \"./src/assets/css/common/variables\";\r\n\r\n.services {\r\n  .custom-container {\r\n    .content-section {\r\n      padding: 5rem 0rem;\r\n      min-height: 55vh;\r\n      background: #E0E7FF;\r\n\r\n      .page-title {\r\n        font-size: $page-title;\r\n        text-align: center;\r\n        color: #08245A;\r\n\r\n        &::after {\r\n          content: \"\";\r\n          display: block;\r\n          height: 8px;\r\n          width: 60px;\r\n          background: #08245A;\r\n          margin: .7rem auto 0;\r\n          border-radius: 20px;\r\n        }\r\n      }\r\n\r\n      .content-body {\r\n        margin: 3rem auto 0;\r\n        max-width: 1280px;\r\n\r\n        .custom-service-card {\r\n          background: #fff;\r\n          height: 300px;\r\n          padding: 1rem;\r\n          border-radius: 12px;\r\n          margin-bottom: 2.5rem;\r\n          cursor: pointer;\r\n          transition: 0.5s;\r\n          box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\r\n\r\n          .custom-service-card-header {\r\n            background: rgba(53, 78, 128, 0.90);\r\n            height: 200px;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            border-radius: 12px;\r\n            clip-path: polygon(0 0, 100% 0, 100% 80%, 0% 100%);\r\n\r\n            img {\r\n              width: 85px;\r\n              height: 100px;\r\n              object-fit: contain;\r\n              //filter: brightness(0) invert(1);\r\n            }\r\n          }\r\n\r\n          .custom-service-card-body {\r\n            height: calc(300px - 1rem - 200px);\r\n            text-align: center;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n\r\n            .service-name {\r\n              font-weight: 500;\r\n              font-size: 1.1rem;\r\n              color: #08245A;\r\n              font-family: \"Roboto\", \"SolaimanLipi\", sans-serif;\r\n            }\r\n          }\r\n\r\n          &:hover {\r\n            transform: translateY(-10px);\r\n            box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","// Color palette\r\n$color-blue-light: #d0dbff;\r\n$color-blue: #354e80;\r\n$color-blue-dark: #1c2f56;\r\n\r\n$color-sky: #e0e7ff;\r\n\r\n$color-yellow-light: #fffdef;\r\n$color-yellow: #fae205;\r\n\r\n$color-black-30: #e1e2e2;\r\n\r\n$section-heading-font-size: 2.1rem;\r\n$page-title: 2.2rem;\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
